import { Avatar, Button, Input, message, Select } from 'antd';
import React, { useState } from 'react';
import { countries } from '../../../config/variable';
import Flag from 'react-world-flags';
import { editUser } from '../../../api/auth';
import { useDispatch } from 'react-redux';
import { getUsers } from '../../../redux/actions/AllActions';

const { Option } = Select;

const EditUser = ({ user, handleEditCancel }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        name: user?.name || "",
        designation: user?.designation || "",
        countryCode: user?.countryCode || "",
        email: user?.email || "",
        phoneNumber: user?.phoneNumber || "",
        businessName: user?.businessName || "",
        gstNumber: user?.gstNumber || "",
        entryType: user?.entryType || "",
        industryType: user?.industryType || "",
        businessCategory: user?.businessCategory || "",
        address: user?.businessAddress?.address || "",
        street: user?.businessAddress?.street || "", 
        state: user?.businessAddress?.state || "",
        city : user?.businessAddress?.city || "",
        country: user?.businessAddress?.country || "",
        postalCode: user?.businessAddress?.postalCode || "",
        businessOverview: user?.businessOverview || "",
        profilePic: user?.profilePic || ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (value) => {
        console.log('the value',value)
        setFormData((prev) => ({ ...prev, countryCode: value }));
    };

    const handleSubmit = async () => {
        const obj = {};
        if (!formData?.name) obj.Name = "Enter Name"
        if (!formData?.email) obj.Email = "Enter Email"
        if (!formData?.phoneNumber) obj.Phonenumber = "Enter Phone Number"
        if (!formData?.countryCode) obj.Countrycode = "Enter CountryCode"
        if (Object.keys(obj).length > 0) {
            console.log('the ', Object.keys(obj).join(", "))
            message.error(`Kindly Enter: ${Object.keys(obj).join(", ")}`);
            
        }
        try {
            await editUser({
                id: user?._id,
                name: formData.name,
                designation: formData.designation,
                countryCode: formData.countryCode,
                email: formData.email,
                phoneNumber: formData.phoneNumber,
                businessName: formData.businessName,
                gstNumber: formData.gstNumber,
                entryType: formData.entryType,
                industryType: formData.industryType,
                businessCategory: formData.businessCategory,
                address: formData?.address,
                city: formData?.city,
                street: formData.street,
                state: formData.state,
                country: formData.country,
                postalCode: formData.postalCode,
                businessOverview: formData.businessOverview,
            })
            
            fetch();
            message.success("User is updated successfully.")
        
        } catch (e) {
            console.log('the error in edit user', e);
            
        }
    }
    
    const fetch = () => {
        dispatch(getUsers());

    }



    return (
        <div>
            <Avatar
                src={
                    typeof formData.profilePic === "string"
                        ? formData.profilePic
                        : formData.profilePic
                            ? URL.createObjectURL(formData.profilePic)
                            : ""
                }
            />

            <div>
                <label>Name <span className='redColor'>*</span></label>
                <Input name="name" onChange={handleChange} value={formData.name} />
                <br /><br />

                <label>Designation<span className='redColor'>*</span></label>
                <Input name="designation" onChange={handleChange} value={formData.designation} />
                <br /><br />

                <label>Email<span className='redColor'>*</span></label>
                <Input name="email" onChange={handleChange} value={formData.email} />
                <br /><br />

                <label>Phone Number</label>
                <div className='flex'>
                    <Select value={formData.countryCode} onChange={handleSelectChange}>
                        <Option value="">Select Country</Option>
                        {countries?.map((country) => (
                            <Option key={country.code} value={country.code}>
                                <Flag
                                    code={country.flag}
                                    alt={country.code}
                                    style={{ width: '20px',  }}
                                />
                                {/* {country.code} */}
                            </Option>
                        ))}
                    </Select>
                    <Input name="phoneNumber" onChange={handleChange} value={formData.phoneNumber} />
                </div>
                <br /><br />

                <label>Business Name</label>
                <Input name="businessName" onChange={handleChange} value={formData.businessName} />
                <br /><br />

                <label>GST Number</label>
                <Input name="gstNumber" onChange={handleChange} value={formData.gstNumber} />
                <br /><br />

                <label>Entry Type</label>
                <Input name="entryType" onChange={handleChange} value={formData.entryType} />
                <br /><br />

                <label>Industry Type</label>
                <Input name="industryType" onChange={handleChange} value={formData.industryType} />
                <br /><br />

                <label>Business Category</label>
                <Input name="businessCategory" onChange={handleChange} value={formData.businessCategory} />
                <br /><br />

                <label>Address</label>
                <Input name="address" onChange={handleChange} value={formData.address} />
                <br /><br />

                <label>Street</label>
                <Input name="street" onChange={handleChange} value={formData.street} />
                <br /><br />

                <label>City</label>
                <Input name="state" onChange={handleChange} value={formData.city} />
                <br /><br />  

                <label>State</label>
                <Input name="state" onChange={handleChange} value={formData.state} />
                <br /><br />  
                <label>Country</label>
                <Input name="country" onChange={handleChange} value={formData.country} />
                <br /><br />

                <label>Postal Code</label>
                <Input name="postalCode" onChange={handleChange} value={formData.postalCode} />
                <br /><br />

                <label>Business Overview</label>
                <Input name="businessOverview" onChange={handleChange} value={formData.businessOverview} />
                <br /><br />
            </div>
            <Button
                onClick ={handleSubmit}
                type ={'primary'}
            >Submit</Button>
        </div>
    );
};

export default EditUser;
